/* @flow */

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudienceSmsMembershipStats as GetAudienceSmsMembershipStatsQuery,
    GetAudienceSmsMembershipStatsVariables,
    SmsMembershipStatsFragment,
} from 'nutshell-graphql-types';

import GET_AUDIENCE_SMS_MEMBERSHIP_STATS from '../queries/get-audience-sms-membership-stats.graphql';

export const useGetAudienceSmsMembershipStats = (
    audienceId: string
): {
    smsMembershipStats: SmsMembershipStatsFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAudienceSmsMembershipStatsQuery,
        GetAudienceSmsMembershipStatsVariables
    >(GET_AUDIENCE_SMS_MEMBERSHIP_STATS, {
        variables: {
            audienceId,
        },
    });

    return {
        smsMembershipStats: data?.audience?.smsMembershipStatsRealtime,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
